import React, { useEffect, useRef } from 'react';
import Image from 'next/image';
import classNames from 'classnames';
import IconFont from '$/components/IconFont';
import { V3CanvasHomeCategoryInfo } from '$/domains/caseV3/type';
import styles from './index.module.scss';

interface HotPromptCategoryTabsProps {
  categoryList: V3CanvasHomeCategoryInfo[];
  selectedCategory: V3CanvasHomeCategoryInfo | null;
  onCategoryChange: (category: V3CanvasHomeCategoryInfo | null) => void;
}

/**
 * 渲染 BaseHomeNew 首屏的场景分类标签。
 */
function HotPromptCategoryTabs({
  categoryList,
  selectedCategory,
  onCategoryChange,
}: HotPromptCategoryTabsProps) {
  const hasDefaultSelectedRef = useRef(false);

  /**
   * 分类数据首次加载完成后默认选中第一项，避免用户手动取消后再次自动选中。
   */
  useEffect(() => {
    if (hasDefaultSelectedRef.current) return;
    if (selectedCategory) {
      hasDefaultSelectedRef.current = true;
      return;
    }
    if (!categoryList?.length) return;
    hasDefaultSelectedRef.current = true;
    onCategoryChange(categoryList[0]);
  }, [categoryList, onCategoryChange, selectedCategory]);

  /**
   * 处理分类点击：选中时加载卡片，再次点击选中项时关闭分类筛选。
   */
  const handleCategoryClick = (category: V3CanvasHomeCategoryInfo, positionId: number) => {
    if (selectedCategory?.category_id === category.category_id) {
      onCategoryChange(null);
      return;
    }

    window.mtstat?.track('roboneo_callword_tag_click', {
      position_id: positionId,
      tag: category.name,
      click_type: 'tag_click',
      agent_type: 'agent_teams',
    });

    // 设置选中的分类
    onCategoryChange(category);
  };

  if (!categoryList || categoryList.length === 0) {
    return null;
  }

  return (
    <div className={styles.HotPromptCategoryTabs}>
      {categoryList.map((category, index) => {
        const isSelected = selectedCategory?.category_id === category.category_id;
        const icon = category.iconfont || '';

        return (
          <div
            key={category.category_id}
            className={classNames(styles.categoryTab, styles[`theme_${index % 8}`], {
              [styles.selected]: isSelected,
            })}
            onClick={() => handleCategoryClick(category, index + 1)}
          >
            {icon?.startsWith('http') ? (
              <Image src={icon} alt="" width={16} height={16} />
            ) : (
              <IconFont name={icon} fontSize={16} />
            )}
            <span className={styles.categoryName}>{category.name}</span>
            {isSelected && (
              <span className={styles.closeIcon}>
                <IconFont name="crossFill" fontSize={8} />
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default React.memo(HotPromptCategoryTabs);
